import React from "react";
import { useModal } from "@/hooks/modals/useModal";
import RegistrationModal from "./RegistrationModal";

// ==================== 主组件 ====================
/**
 * 供应商注册弹窗全局适配器
 * 用于将 RegistrationModal 适配到全局弹窗管理系统
 */
export const RegistrationModalGlobal: React.FC = () => {
  const { open, props, closeModal } = useModal("SUPPLIER_REGISTER");
  const { onSuccess, recordId, mode } = props;

  // 判断是否为工作台待办模式
  // 当 mode 为 'inReview' 时,表示从工作台待办打开,此时 recordId 为 businessId
  const isFromWorkbench = mode === "inReview";

  const handleCancel = () => {
    closeModal();
  };

  const handleSuccess = () => {
    onSuccess?.();
    closeModal();
  };

  return (
    <RegistrationModal
      open={open}
      mode={mode === "inReview" ? "audit" : mode || "register"}
      currentRecord={{ id: recordId }}
      isFromWorkbench={isFromWorkbench}
      onCancel={handleCancel}
      onSuccess={handleSuccess}
    />
  );
};

export default RegistrationModalGlobal;
